/* @flow */

import linhaTempoLogAtivacao from './linha-tempo-ativacao';

import { type LogAtivacao } from '../../empresa/types';

type Param = {
    logsAtivacao: LogAtivacao[],
};

const detalhes = ({
    logsAtivacao,
}: Param) => `
<div class="m-form m-form--label-align-right">
    <div class="m-portlet__body">
        <div class="row">
            <div class="col-xl-9 col-lg-8">
                <div class="m-portlet m-portlet--full-height">
                    <div class="m-portlet__body">
                        ${logsAtivacao.length ? `
                            <div class="m-form__heading">
                                <h3 class="m-form__heading-title">Logs de ativação:</h3>
                            </div>
                            ${linhaTempoLogAtivacao(logsAtivacao)}
                        ` : `
                        <div class="m-portlet__body">
                            <div class="m-form__heading">
                            <h3 class="m-form__heading-title">Logs de ativação:</h3>
                            </div>
                            <div class="m-timeline-3">
                            <div class="m-timeline-3__items">
                                <div class="alert alert-danger" role="alert">
                                    <strong>
                                        <i class="m-nav__link-icon la la-eye-slash">
                                        </i>&nbsp;
                                    </strong>
                                Não há logs de ativação desta empresa
                                </div>
                            </div>
                            </div>
                        </div>
                     `}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
`;

export default detalhes;
